
import React, { useState, useEffect } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
// import { initializeAndTrack } from 'gatsby-plugin-gdpr-cookies'
import '../styles/cookies.css'

const Cookies = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [consent, setConsent] = useState({
    performance: false,
    functional: false,
    targeting: false,
  });

  const [accordion, setAccordion] = useState({
    strictly: false,
    performance: false,
    functional: false,
    targeting: false,
  });

  useEffect(() => {
    const savedConsent = {
      performance: localStorage.getItem('performanceConsent') === 'true',
      functional: localStorage.getItem('functionalConsent') === 'true',
      targeting: localStorage.getItem('targetingConsent') === 'true',
    };
    setConsent(savedConsent);
  }, []);

  const handleToggle = (type) => {
    const updatedConsent = { ...consent, [type]: !consent[type] };
    setConsent(updatedConsent);
    localStorage.setItem(`${type}Consent`, !consent[type]);
    // initializeAndTrack(updatedConsent);
  };

  const handleAccordionToggle = (type) => {
    setAccordion((prevAccordion) => ({ ...prevAccordion, [type]: !prevAccordion[type] }));
  };

  const handleRejectAll = () => {
    setConsent({ performance: false, functional: false, targeting: false });
    localStorage.setItem('performanceConsent', false);
    localStorage.setItem('functionalConsent', false);
    localStorage.setItem('targetingConsent', false);
    setIsVisible(false)
    // initializeAndTrack({ performance: false, functional: false, targeting: false });
  };

  const handleAcceptAll = () => {
    setIsVisible(false);
  };

  // const handleRejectAll = () => {
  //   setIsVisible(false);
  // };

  const handleConfirmChoices = () => {
    localStorage.setItem('performanceConsent', consent.performance);
    localStorage.setItem('functionalConsent', consent.functional);
    localStorage.setItem('targetingConsent', consent.targeting);
    console.log('Confirmed choices:', consent);
    setIsVisible(false)
  };

  // if (!isVisible) {
  //   return null;
  // }

  const setCookies = () => {
    if(!isVisible){
    setIsVisible(true)
    }
  }

  return (
    <div className='print:hidden'>
      <div className={`${isVisible ? 'z-40' : 'z-50'} fixed bottom-0 flex items-end p-2.5 pb-3 justify-start`}>
        <span className='cursor-pointer' onClick={setCookies}>
      <StaticImage src='../images/cookies.webp' alt='Cookies' />
      </span>
      </div>
    <div className={`${isVisible ? 'fixed z-50 no-scroll' : 'hidden'} inset-0 flex items-center justify-center`}>
    <div className='bg-white cookies overflow-auto lg:h-5/6'>
        <div className='p-1 lg:p-3 w-full flex justify-end'>
            <span onClick={handleRejectAll} className='font-bold text-gray-700 text-_2432 cursor-pointer'>x</span>
        </div>
                <hr />
      <div className="bg-white pt-1 lg:pt-6 p-6 pb-0 min-w-xs lg:max-w-xl w-full">
        <h2 className="text-_1625 font-semibold mb-4 font-goldplay">Privacy Preference Centre</h2>
        <div className=''>
        <p className="text-_1212 lg:text-_1620 mb-1 font-goldplay font-semibold text-gray-800">
          When you visit any website, it may store or retrieve information on your browser, mostly in the form of cookies. This information might be about you, your preferences or your device and is mostly used to make the site work as you expect it to. The information does not usually directly identify you, but it can give you a more personalized web experience. Because we respect your right to privacy, you can choose not to allow some types of cookies. Click on the different category headings to find out more and change our default settings. However, blocking some types of cookies may impact your experience of the site and the services we are able to offer.
        </p>
        </div>
        <div className="mb-4">
          <button className="text-blue-500 text-_1212 lg:text-_1625 mb-2">More information</button>
        </div>
        <div className="mb-4">
          <h2 className="text-sm lg:text-lg font-semibold mb-4 font-goldplay">Manage Consent Preferences</h2>
        </div>
        <div className="mb-6">
          <div className='cookies-always'>
          <div className="flex items-center p-2 justify-between">
            <div className='flex gap-2 items-center' onClick={() => handleAccordionToggle('strictly')}>
            <span className='text-_1832 font-black text-gray-800 cursor-pointer'>{accordion.strictly ? '-' : '+'}</span>
            <span className="text-_1212 lg:text-_1625 font-semibold cursor-pointer">Strictly Necessary Cookies</span>
            </div>
            <span className="text-_1212 lg:text-_1625 font-semibold text-blue-500">Always Active</span>
          </div>
          {accordion.strictly && <div className="pl-4 pb-4 text-_1212 lg:text-_1418 text-gray-600">Description about Performance Cookies.</div>}
          </div>
          <div className='cookies-list p-2'>
          <div className="flex items-center justify-between">
                <div className='flex gap-2 items-center' onClick={() => handleAccordionToggle('performance')}>
                  <span className={`text-_1832 font-black text-gray-800 cursor-pointer`}>{accordion.performance ? '-' : '+'}</span>
                  <span className="text-_1212 lg:text-_1625 font-semibold cursor-pointer">Performance Cookies</span>
                </div>
                <label className="switch">
                  <input type="checkbox" checked={consent.performance} onChange={() => handleToggle('performance')} />
                  <span className="slider round"></span>
                </label>
          </div>
          {accordion.performance && <div className="p-2 text-_1212 lg:text-_1418 text-gray-600">Description about Performance Cookies.</div>}
          </div>
          <div className='cookies-list p-2'>
          <div className="flex items-center justify-between">
                <div className='flex gap-2 items-center' onClick={() => handleAccordionToggle('functional')}>
                  <span className={`text-_1832 font-black text-gray-800 cursor-pointer`}>{accordion.functional ? '-' : '+'}</span>
                  <span className="text-_1212 lg:text-_1625 font-semibold cursor-pointer">Functional Cookies</span>
                </div>
                <label className="switch">
                  <input type="checkbox" checked={consent.functional} onChange={() => handleToggle('functional')} />
                  <span className="slider round"></span>
                </label>
              </div>
              {accordion.functional && <div className="p-2 text-_1212 lg:text-_1418 text-gray-600">Description about Functional Cookies.</div>}
              </div>
             <div className='cookies-list p-2'>
          <div className="flex items-center justify-between">
                <div className='flex gap-2 items-center' onClick={() => handleAccordionToggle('targeting')}>
                  <span className={`text-_1832 font-black text-gray-800 cursor-pointer`}>{accordion.targeting ? '-' : '+'}</span>
                  <span className="text-_1212 lg:text-_1625 font-semibold cursor-pointer">Targeting Cookies</span>
                </div>
                <label className="switch">
                  <input type="checkbox" checked={consent.targeting} onChange={() => handleToggle('targeting')} />
                  <span className="slider round"></span>
                </label>
              </div>
              {accordion.targeting && <div className="p-2 text-_1212 lg:text-_1418 text-gray-600">Description about Targeting Cookies.</div>}
          </div>
        </div>
      </div>
      <hr />
      <div className='p-3'>
        <div className="flex justify-end space-x-4 font-goldplay">
          <button onClick={handleRejectAll} className="bg-blue-500 text-_1212 lg:text-_1625 text-white font-semibold py-2 px-4">Reject All</button>
          <button onClick={handleConfirmChoices} className="bg-blue-500 text-_1212 lg:text-_1625 text-white font-semibold py-2 px-4">Confirm My Choices</button>
        </div>
      </div>
      </div>
    </div>
    </div>
    
  );
};

export default Cookies;
